export enum MeetingType {
  Interview = 'Interview',

  Meeting = 'Meeting',
}
